/**
 * @generated SignedSource<<c806e43958ad2277c3ae3dfb81f27a4d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type bundledNewsletterCategoryItemSlideshowNewsletterCategory$data = {
  readonly newsletters: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityId: string;
        readonly " $fragmentSpreads": FragmentRefs<"bundledNewsletterItemNewsletter">;
      };
    }>;
  };
  readonly " $fragmentType": "bundledNewsletterCategoryItemSlideshowNewsletterCategory";
};
export type bundledNewsletterCategoryItemSlideshowNewsletterCategory$key = {
  readonly " $data"?: bundledNewsletterCategoryItemSlideshowNewsletterCategory$data;
  readonly " $fragmentSpreads": FragmentRefs<"bundledNewsletterCategoryItemSlideshowNewsletterCategory">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "bundledNewslettersEntityIds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "bundledNewsletterCategoryItemSlideshowNewsletterCategory",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "entityIds",
              "variableName": "bundledNewslettersEntityIds"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 100
        }
      ],
      "concreteType": "NewsletterConnection",
      "kind": "LinkedField",
      "name": "newsletters",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NewsletterEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Newsletter",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entityId",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "bundledNewsletterItemNewsletter"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "158b9e8acdbfe3db074f28191c33c4f8";

export default node;
